// Detect pinch gestures and invoke the provided callback
export const detectPinchGesture = (onPinch, scale) => {
  let initialDistance = null; // Initial distance between two touch points
  let previousDistance = null; // Distance between two touch points in the previous touch move event
  let currentScale = scale || 1; // Current scaling factor

  // Calculates the distance between two touch points using their client coordinates
  const calculateDistance = (touch1, touch2) => {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.hypot(dx, dy);
  };

  // Handles the touch start event and initializes the initial and previous distances
  const handleTouchStart = (event) => {
    const {touches} = event;
    if (touches.length === 2) {
      const [touch1, touch2] = touches;
      initialDistance = calculateDistance(touch1, touch2);
      previousDistance = initialDistance;
      event.preventDefault();
    }
  };

  // Handles the touch move event and calculates the scaling factor based on the touch distances
  const handleTouchMove = (event) => {
    const {touches} = event;
    if (touches.length === 2) {
      const [touch1, touch2] = touches;
      const currentDistance = calculateDistance(touch1, touch2);

      // Calculate the scaling factor and clamp it between 0.1 and 2
      if (initialDistance && previousDistance) {
        const scaleFactor = currentDistance / previousDistance;
        const newScale = currentScale * scaleFactor;
        const clampedScale = Math.min(Math.max(newScale, 0.1), 2);

        // Invoke the onPinch callback with the clampedScale value
        if (onPinch && typeof onPinch === 'function') {
          onPinch(clampedScale);
        }

        currentScale = clampedScale;
      }

      previousDistance = currentDistance;
      event.preventDefault(); // Prevents the default touch behavior
    }
  };

  // Handles the touch end event and resets the distances
  const handleTouchEnd = () => {
    initialDistance = null;
    previousDistance = null;
  };

  // Add event listeners for touch events
  document.addEventListener('touchstart', handleTouchStart);
  document.addEventListener('touchmove', handleTouchMove);
  document.addEventListener('touchend', handleTouchEnd);

  // Return a cleanup function to remove event listeners when the component unmounts
  return () => {
    document.removeEventListener('touchstart', handleTouchStart);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
  };
};
